var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "claim-compensation-type view" }, [
    _vm.isE2EFlow
      ? _c(
          "div",
          { staticClass: "view_top" },
          [
            _c("ma-navbar-stepper", {
              attrs: { numberOfStep: 3, textOfStep: _vm.$t("stepper.step3") },
            }),
          ],
          1
        )
      : _vm._e(),
    _c("div", { staticClass: "view_content" }, [
      _c("div", { staticClass: "view_content_title" }, [
        _c("p", { staticClass: "headline-medium mg" }, [
          _vm._v(_vm._s(_vm.$t("claim.compensationType.title"))),
        ]),
      ]),
      _c(
        "div",
        { staticClass: "claim-compensation-type-content" },
        [
          _vm.damagesWarranty.length
            ? _c("p", { staticClass: "text-medium bold mg mg--t-5" }, [
                _vm._v(_vm._s(_vm.$t("claim.compensationType.propertyDamage"))),
              ])
            : _vm._e(),
          _vm._l(_vm.damagesWarranty, function (damage) {
            return _c("p", { staticClass: "mg mg--t-4" }, [
              _vm._v(_vm._s(damage)),
            ])
          }),
          _c(
            "div",
            { staticClass: "claim-compensation-type_slider" },
            [
              _c(
                "slider",
                { attrs: { totalSlides: _vm.compensationSlides.length } },
                _vm._l(_vm.compensationSlides, function (compensation, index) {
                  return _c(
                    "div",
                    {
                      staticClass:
                        "claim-compensation-type_slide slide-wrapper",
                      attrs: { slot: "slide-" + index },
                      slot: "slide-" + index,
                    },
                    [
                      _c("div", { staticClass: "compensation-slider" }, [
                        _c(
                          "div",
                          { staticClass: "compensation-slider__header" },
                          [
                            _c("img", {
                              staticClass: "claim-compensation-type_slide_img",
                              attrs: {
                                src: require("@/assets/images/carrousel/" +
                                  compensation.img +
                                  ".png"),
                              },
                            }),
                            compensation.recommended
                              ? _c(
                                  "p",
                                  { staticClass: "compensation-slider__tag" },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t(
                                          "claim.compensationType.e2eCompensations.ourRecommendation"
                                        )
                                      )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "p",
                          {
                            staticClass:
                              "claim-compensation-type_slide_title mg mg--t-2",
                          },
                          [_vm._v(_vm._s(compensation.title))]
                        ),
                        compensation.text
                          ? _c(
                              "p",
                              {
                                staticClass:
                                  "claim-compensation-type_slide_text mg mg--t-2",
                              },
                              [_vm._v(_vm._s(compensation.text))]
                            )
                          : _vm._e(),
                        _c(
                          "div",
                          { staticClass: "compensation-slider__ammount" },
                          [
                            compensation.indemnisation
                              ? _c(
                                  "p",
                                  {
                                    staticClass:
                                      "claim-compensation-type_slide_text2 mg mg--t-2",
                                  },
                                  [
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.replaceDots(
                                            compensation.indemnisation
                                          )
                                        )
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            compensation.amount
                              ? _c(
                                  "h2",
                                  {
                                    staticClass:
                                      "headline-large-bold blueDark mg mg--t-2",
                                  },
                                  [
                                    _vm._v(
                                      _vm._s(
                                        _vm.replaceDots(compensation.amount)
                                      ) + "€"
                                    ),
                                  ]
                                )
                              : _vm._e(),
                          ]
                        ),
                        _c(
                          "button",
                          {
                            staticClass:
                              "claim-compensation-type_slide_link btn mainBlue",
                            on: {
                              click: function ($event) {
                                return _vm.handleLinkClick(
                                  compensation.transition
                                )
                              },
                            },
                          },
                          [_c("p", [_vm._v(_vm._s(compensation.link))])]
                        ),
                      ]),
                    ]
                  )
                }),
                0
              ),
            ],
            1
          ),
        ],
        2
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }